import React, { useState, useEffect, useRef } from 'react';

import { IVideoModuleFields } from '../../../types/contentful';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';
import { captureError } from '../../utils/datadogRum';

import { Lightbox } from '../VideoBlock/Lightbox';

import { PlayIcon, VideoButton, VideoWrapper } from './styles';

export function VideoPlayer({
  title,
  vimeoId,
  rounded,
  loop,
  mp4video,
  fallbackImage
}: IVideoModuleFields) {
  const [showingVideo, setShowingVideo] = useState(false);
  const backgroundVideoPlayer = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    backgroundVideoPlayer.current?.play()?.catch((err: DOMException) => {
      trackWithFingerprint('Autoplay Failed');
      captureError(err);
    });
  }, []);

  const toggleVideo = (displayVideo: boolean) => {
    setShowingVideo(displayVideo);
    if (displayVideo) {
      trackWithFingerprint('Video Opened', {
        page_url: window.location.href
      });
    } else {
      trackWithFingerprint('Video Closed', {
        page_url: window.location.href
      });
      document.getElementById('gl-video-play-button')?.focus();
    }
  };

  return (
    <VideoWrapper data-blockid="videoModuleWrapper">
      <video
        ref={backgroundVideoPlayer}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: rounded ? 104 : 0
        }}
        loop={loop!}
        poster={fallbackImage?.fields?.file?.url}
        playsInline
        muted
        controls={false}
      >
        <track kind="captions" />
        <source src={mp4video?.fields?.file?.url} />
        Your browser does not support HTML video.
      </video>
      <VideoButton
        id="gl-video-play-button"
        onClick={(e: any) => {
          toggleVideo(true);
          e.currentTarget.blur();
        }}
        aria-label="Play video"
        data-testid="videomodule-button"
      >
        <PlayIcon
          width="80"
          height="80"
          viewBox="0 0 100 100"
          role="img"
          data-testid="assetWith5050Text-video"
        >
          <path
            opacity={0.8}
            d="M0 24C0 10.745 10.745 0 24 0h32c13.255 0 24 10.745 24 24v32c0 13.255-10.745 24-24 24H24C10.745 80 0 69.255 0 56V24z"
            fill="#1D252C"
          />
          <path
            d="M49.666 37.935c1.333.77 1.333 2.694 0 3.464l-13.5 7.794c-1.333.77-3-.192-3-1.732V31.873c0-1.54 1.667-2.502 3-1.733l13.5 7.795z"
            fill="#3BBFAD"
          />
        </PlayIcon>
      </VideoButton>
      {vimeoId && title && (
        <Lightbox
          title={title}
          showingVideo={showingVideo}
          setShowingVideo={toggleVideo}
          vimeoId={vimeoId}
        />
      )}
    </VideoWrapper>
  );
}
